import { gql } from "apollo-boost";

export const SEND_VERIFICATION_CODE_WITH_RATE_LIMIT = gql`
  mutation verificationCodeSendWithRateLimit(
    $verificationChannel: String!
  ) {
    verificationCodeSendWithRateLimit(
      verificationChannel: $verificationChannel, 
    ) {
      status
      message
    }
  }
`;

export const CHECK_VERIFICATION_CODE_WITH_RATE_LIMIT = gql`
  mutation verificationCodeCheckWithRateLimit(
    $verificationChannel: String!
    $code: String!
  ) {
    verificationCodeCheckWithRateLimit(
      verificationChannel: $verificationChannel
      code: $code
    ) {
      valid
      remainingTries
      displayMessage
    }
  }
`;